import { ApiRes } from "@/api/api-res";
import { UserSummaryItem } from "@/models/user-summary/UserSummaryItem";

export class ConversionSummary extends UserSummaryItem {
  public static build(json: ApiRes.UserSummaryConversion): ConversionSummary {
    return new ConversionSummary(json.cv_name, json.count, json.rate);
  }
}
